import React from 'react';
import { Col, Row } from 'reactstrap';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import colors from 'config/colors';

// Spring Boot 4 changed how Spring Data serializes a Page<T> to JSON: pagination metadata (size,
// number, totalElements, totalPages) is now nested under a "page" object instead of sitting at
// the top level next to "content", and "first"/"last"/"numberOfElements" aren't sent at all
// anymore. Every page that spreads a raw Page response into this component broke at once when
// the backend upgraded. Rather than patch every caller, accept both shapes here and derive
// whatever the new format dropped from what it still gives us.
const Page = props => {
  const {
    style = null,
    first,
    last,
    number,
    numberOfElements,
    size,
    totalElements,
    totalPages,
    content,
    page: nestedPage,
    fetchPageData,
    isLoading = false,
  } = props;

  const pageNumber = number ?? nestedPage?.number ?? 0;
  const pageSize = size ?? nestedPage?.size ?? 0;
  const total = totalElements ?? nestedPage?.totalElements ?? 0;
  const pages = totalPages ?? nestedPage?.totalPages ?? 0;
  const elementsOnPage = numberOfElements ?? content?.length ?? 0;
  const isFirst = first ?? pageNumber <= 0;
  const isLast = last ?? pageNumber >= pages - 1;

  const handlePageChange = pageNum => {
    !isLoading && fetchPageData(pageNum);
  };

  const btnStyle = {
    padding: 4,
    margin: '0 2px',
    backgroundColor: '#f5f2f8',
  };

  return (
    <Row style={{ ...style, alignItems: 'center' }} className="flex-wrap">
      <Col xs={12} sm={6} md={6} lg={6} style={{ color: '#6b778a', fontSize: 13, marginBottom: 4 }}>
        Showing <b style={{ color: '#2b2b2b' }}>{pageNumber * pageSize + 1}</b> -{' '}
        <b style={{ color: '#2b2b2b' }}>{pageNumber * pageSize + elementsOnPage}</b> of{' '}
        <b style={{ color: '#2b2b2b' }}>{total}</b>
      </Col>
      <Col
        xs={12}
        sm={6}
        md={6}
        lg={6}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
        <IconButton size="small" style={btnStyle} disabled={isFirst} onClick={() => handlePageChange(1)}>
          <FirstPageIcon fontSize="small" />
        </IconButton>
        <IconButton size="small" style={btnStyle} disabled={isFirst} onClick={() => handlePageChange(pageNumber)}>
          <ChevronLeftIcon fontSize="small" />
        </IconButton>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 30,
            height: 30,
            borderRadius: 15,
            margin: '0 4px',
            fontWeight: 'bold',
            fontSize: 13,
            color: '#fff',
            backgroundColor: colors.accent,
          }}>
          {pageNumber + 1}
        </span>
        <span style={{ color: '#8b95a1', fontSize: 13, marginRight: 4 }}>of {pages || 1}</span>
        <IconButton size="small" style={btnStyle} disabled={isLast} onClick={() => handlePageChange(pageNumber + 2)}>
          <ChevronRightIcon fontSize="small" />
        </IconButton>
        <IconButton size="small" style={btnStyle} disabled={isLast} onClick={() => handlePageChange(pages)}>
          <LastPageIcon fontSize="small" />
        </IconButton>
      </Col>
    </Row>
  );
};

export default Page;
